import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';
import { profileUrl, raceUrl } from '../../helpers/urlBuilder';
import classNames from 'classnames';

const onClick = (event) => {
    event.stopPropagation();
};


/**
 * Table cell representing Horse and his Sire
 *
 * @param {{}} props
 * @constructor
 */
const HorseSireCell = ({ rowData, customCell: { options: fieldNames } }) => (
    <span>
        {(() => {
            if (!rowData[fieldNames.horseUid]) {
                return rowData[fieldNames.horseName];
            }

            return (
                <a
                    href={profileUrl(
                        'horse',
                        rowData[fieldNames.horseUid],
                        rowData[fieldNames.horseName]
                    )}
                    className="js-popupLink ui-link ui-link_table"
                    onClick={onClick}
                >
                    {rowData[fieldNames.horseName]}
                    <Svg
                        iconName="right"
                        size="XSmall"
                    />
                </a>
            );
        })()}
        <br className={classNames(fieldNames.breakClassName)} />
        {(() => {
            if (!rowData[fieldNames.sireUid]) {
                return (
                    <span
                        className={classNames(fieldNames.sireClassName)}
                    >
                        {rowData[fieldNames.sireName]}
                    </span>
                );
            }

            return (
                <a
                    href={profileUrl(
                        'horse',
                        rowData[fieldNames.sireUid],
                        rowData[fieldNames.sireName]
                    )}
                    className={classNames(
                        'js-popupLink ui-link ui-link_table',
                        fieldNames.sireClassName
                    )}
                    onClick={onClick}
                >
                    {rowData[fieldNames.sireName]}
                    <Svg
                        iconName="right"
                        size="XSmall"
                    />
                </a>
            );
        })()}
        {(() => {
            if (!rowData[fieldNames.entered] || !rowData[fieldNames.entryDetails]) {
                return '';
            }
            return (
                <div>
                    <a
                        href={raceUrl(
                            rowData[fieldNames.entryDetails][fieldNames.courseId],
                            rowData[fieldNames.entryDetails][fieldNames.courseName],
                            rowData[fieldNames.entryDetails][fieldNames.raceDate],
                            rowData[fieldNames.entryDetails][fieldNames.raceId],
                        )}
                        className="ui-link ui-btn ui-btn_small ui-btn_secondary sales__entryLabel"
                        onClick={onClick}
                        target="_blank"
                    >
                        ENTRY
                    </a>
                </div>
            );
        })()}
    </span>
);

HorseSireCell.propTypes = {
    /**
     * Single row data
     */
    rowData: PropTypes.object.isRequired,
    /**
     * Name of current column
     */
    columnName: PropTypes.string.isRequired,
    /**
     * Custom cell component and options
     */
    customCell: PropTypes.object.isRequired
};

export default HorseSireCell;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/HorseSireCell.js